import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { MerchantType } from 'types/types'

interface MerchantDetailsSummaryProps {
  merchant: MerchantType
}

export const MerchantDetailsSummary = ({ merchant }: MerchantDetailsSummaryProps) => {
  const { t } = useTranslation()
  return (
    <Box testId="merchant-summary-details" width="full">
      <DataListItem
        id="wallet"
        testId="wallet"
        title={t('wallet')}
        body={merchant?.wallet?.description}
      />
      <DataListItem
        id="merchant-id"
        testId="merchant-id"
        title={t('merchantId')}
        body={ellipseMiddleText(merchant?.merchantId, 20, 10)}
        copyText={merchant?.merchantId}
      />
      <DataListItem
        id="secret-key"
        testId="secret-key"
        title={t('secretKey')}
        body={ellipseMiddleText(merchant?.secret, 20, 10)}
        copyText={merchant?.secret}
      />
      <DataListItem
        id="webhook-url"
        testId="webhook-url"
        title={t('webhookUrl')}
        body={ellipseMiddleText(merchant?.webhookUrl, 20, 10)}
        copyText={merchant?.webhookUrl}
      />
    </Box>
  )
}
